module.exports = __webpack_public_path__ + "fa639bafe67d520df082ca97bf36ec4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chs-logo.png
// module id = 1056
// module chunks = 0